/* eslint no-console: 0 */
// Run this example by adding <%= javascript_pack_tag 'hello_vue' %> (and
// <%= stylesheet_pack_tag 'hello_vue' %> if you have styles in your component)
// to the head of your layout file,
// like app/views/layouts/application.html.erb.
// All it does is render <div>Hello Vue</div> at the bottom of the page.

import Vue from 'vue'
import store from '../store'
import App from '../pages/app.vue'
import router from '../router'
import ElementUI from 'element-ui'
import 'mint-ui/lib/style.css'
import locale from 'element-ui/lib/locale/lang/en'
import VueCurrencyFilter from 'vue-currency-filter'
import axios from 'axios'
import VueTruncate from 'vue-truncate-filter'
import VueI18n from 'vue-i18n'

import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

import tz from 'date-time-format-timezone'
import VueAnalytics from 'vue-analytics'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en-GB',
  fallbackLocale: 'en',
  messages: {
    en: {
    }
  },
  numberFormats: {
    'en-GB': {
      currency: {
        style: 'currency', currency: 'GBP'
      }
    },
    'en-IE': {
      currency: {
        style: 'currency', currency: 'EUR'
      }
    }
  }
})

document.addEventListener('DOMContentLoaded', (event) => {

  const gaId = document.body.getAttribute('data-ga-id')
  if (gaId) {
    Vue.use(VueAnalytics, {
        id: gaId,
        router
    })
  }

})

Vue.use(VueTruncate)
Vue.use(ElementUI, { locale })
Vue.use(VueCurrencyFilter,
    {
      symbol : '£',
      thousandsSeparator: ',',
      fractionCount: 2,
      fractionSeparator: '.',
      symbolPosition: 'front',
      symbolSpacing: false
    })

document.addEventListener('DOMContentLoaded', () => {
  axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

  const app = new Vue({
    el: '#app',
    store,
    router,
    i18n,
    render: h => h(App)
  })
})

